// PROJECT · Auswahllisten und Anzeigedaten des Projekt-Dashboards: der Anlass als feste Liste und die
// Anbindungen (Jira, Asana, …), die bisher nur Platzhalter sind (docs/project-prototype.md). Jeder Wert
// läuft wie echter Text durch react-intl (@adr SPARK-0013-i18n-mandatory-via-react-intl@1).
//
// Der Ordner pages/project ist kein Wegwerf-Prototyp mehr: Projekt und Ausschreibung teilen sich
// darüber dasselbe Dashboard (dashboard-kinds.tsx). Was hier noch Platzhalter ist, steht in
// docs/project-prototype.md; es ersetzt man einzeln, nicht den Ordner.

export interface Msg {
  id: string;
  defaultMessage: string;
}

/** Was im Aktivitätsstrom landet, wenn der Anlass gesetzt wird. */
export const ANLASS_ACTIVITY: Msg = { id: "project.activity.anlass", defaultMessage: "Anlass ergänzt" };

// --- Guided flow (Bernhard's SHARE-Neufassung-Mock, 4 Schritte: Anlass,
// Aufteilen, Einordnen, Team) - "Projekt" as an Anlass label is renamed to
// "Programm" here, see the grill-me naming-collision decision: the new
// Project entity is the canonical cross-repo term (@adr SPARK-0021-project-umbrella-with-projectdocument-cross-repo@1), the Anlass
// category needed a different word, not the same one.

export interface MockAnlassOption {
  id: string;
  title: Msg;
  desc: Msg;
}

export const MOCK_ANLASS_OPTIONS: readonly MockAnlassOption[] = [
  {
    id: "initiative",
    title: { id: "project.guided.anlass.initiative.title", defaultMessage: "Initiative" },
    desc: {
      id: "project.guided.anlass.initiative.desc",
      defaultMessage: "Etwas, das du anstoßen willst, ohne dass jemand es bestellt hat.",
    },
  },
  {
    id: "aufgabe",
    title: { id: "project.guided.anlass.aufgabe.title", defaultMessage: "Aufgabe" },
    desc: {
      id: "project.guided.anlass.aufgabe.desc",
      defaultMessage: "Etwas Abgegrenztes, das getan werden muss. Klein und schnell.",
    },
  },
  {
    id: "programm",
    title: { id: "project.guided.anlass.programm.title", defaultMessage: "Programm" },
    desc: {
      id: "project.guided.anlass.programm.desc",
      defaultMessage: "Etwas Größeres mit Etappen, das in Teile zerfällt.",
    },
  },
  {
    id: "auftrag",
    title: { id: "project.guided.anlass.auftrag.title", defaultMessage: "Auftrag" },
    desc: {
      id: "project.guided.anlass.auftrag.desc",
      defaultMessage: "Ein Kunde, ein vereinbartes Ergebnis, ein Preis.",
    },
  },
  {
    id: "ausschreibung",
    title: { id: "project.guided.anlass.ausschreibung.title", defaultMessage: "Ausschreibung" },
    desc: {
      id: "project.guided.anlass.ausschreibung.desc",
      defaultMessage: "Ein formales Verfahren mit Frist, Formvorgaben und Wertung.",
    },
  },
  {
    id: "planvorstellung",
    title: { id: "project.guided.anlass.planvorstellung.title", defaultMessage: "Planvorstellung" },
    desc: {
      id: "project.guided.anlass.planvorstellung.desc",
      defaultMessage: "Noch eine Idee, aber schon erzählbar. Zahlen sind geschätzt.",
    },
  },
];

export interface MockService {
  id: string;
  icon: string;
  // Brand-adjacent swatch colour, approximated, not the vendor's exact
  // official asset - see grill-me trademark discussion. Icon text is white
  // on all of these, chosen dark/saturated enough for contrast.
  color: string;
  title: Msg;
  desc: Msg;
}

export const MOCK_IMPORT_SERVICES: readonly MockService[] = [
  {
    id: "jira",
    icon: "JI",
    color: "#0052CC",
    title: { id: "project.data.service.jira.title", defaultMessage: "Jira" },
    desc: { id: "project.data.service.jira.desc", defaultMessage: "Tickets als Kontext" },
  },
  {
    id: "asana",
    icon: "AS",
    color: "#F06A6A",
    title: { id: "project.data.service.asana.title", defaultMessage: "Asana" },
    desc: { id: "project.data.service.asana.desc", defaultMessage: "Tasks als Kontext" },
  },
  {
    id: "monday",
    icon: "MO",
    color: "#FF3D57",
    title: { id: "project.data.service.monday.title", defaultMessage: "Monday" },
    desc: { id: "project.data.service.monday.desc", defaultMessage: "Boards als Kontext" },
  },
  {
    id: "trello",
    icon: "TR",
    color: "#0079BF",
    title: { id: "project.data.service.trello.title", defaultMessage: "Trello" },
    desc: { id: "project.data.service.trello.desc", defaultMessage: "Karten als Kontext" },
  },
];
